const style = {
  color: process.env.REACT_APP_COLOR,
  defaultColor: "#C4C4C4",
};

export default style;
